
const moment = require("moment-timezone");
export const convertTimeToUTC = (dateTimeString) => {
  return  moment.utc(dateTimeString, "DD-MM-YYYY HH:mm").tz("America/Denver").format("YYYY-MM-DD HH:mm")
}
export const dateTimeFormat = (dateTimeString) => {
  return  moment.utc(dateTimeString).tz("America/Denver").format('MMM DD, YYYY HH:mm')
}
